import { createZodDto } from "nestjs-zod/dto";
import { couponSchema } from "./coupon";

const updateCouponSchema = couponSchema
  .pick({
    reduction: true,
    userId: true,
    startDate: true,
    endDate: true,
    type: true,
    rateId: true,
  })
  .partial();

export class UpdateCouponDto extends createZodDto(updateCouponSchema) {}
